<template>
  <VChip
    v-if="textKey"
    class="rounded ml-2"
    :class="color"
  >
    <VIcon color="textPrimary">
      {{ icon }}
    </VIcon>
    <span class="ml-1">
      {{ $t(textKey) }}
    </span>
  </VChip>
</template>

<script lang="ts">
export default {
  name: 'SBookingStatusLabel',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import BookingStatusEnum from '@slg/web-customer-shared/src/enum/BookingStatusEnum';

const props = defineProps({
  bookingStatus: {
    required: true,
    type: String,
  },
});

const textKey = ref('');
const icon = ref('');
const color = ref('');

switch (props.bookingStatus) {
  case BookingStatusEnum.COMPLETED:
    textKey.value = 'enums.bookingStatus.COMPLETED';
    icon.value = 'mdi-check';
    color.value = 'green lighten-4';
    break;
  case BookingStatusEnum.CANCELLED:
    textKey.value = 'enums.bookingStatus.CANCELLED';
    icon.value = 'mdi-close';
    color.value = 'deepOrange';
    break;
  case BookingStatusEnum.ABANDONED:
    textKey.value = 'enums.bookingStatus.ABANDONED';
    icon.value = 'mdi-cancel';
    color.value = 'deepOrange';
    break;
  default:
    break;
}
</script>
